import { useEffect } from 'react';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import useAppState from '../../../common/state/appState';
import { MiniHomebaseContainer } from './MiniHomebaseContainer';
import { KmxContainer } from '../../../components/KmxContainer';
import Paper from '@mui/material/Paper';

const ReadyToFind = () => {
    const isLoading = useAppState((state) => state.isLoading);
    const recentlyViewedVehicles = useAppState((state) => state.recentlyViewedVehicles);
    const getRecentlyViewedVehiclesData = useAppState((state) => state.getRecentlyViewedVehiclesData);

    useEffect(() => {
        getRecentlyViewedVehiclesData();
    }, []);

    if (!isLoading && recentlyViewedVehicles.length > 0) {
        return <MiniHomebaseContainer />;
    }

    return (
        <KmxContainer maxWidth="xl" sx={{ my: { xs: 10, sm: 15 } }}>
            <Paper
                elevation={0}
                sx={({ palette }) => ({
                    height: '100%',
                    alignContent: 'center',
                    backgroundColor: palette.primary.faint,
                    borderRadius: { xs: 1.5, sm: 2 },
                    p: { xs: 4, sm: 5 },
                })}
            >
                <Stack
                    useFlexGap
                    spacing={2}
                    direction={{ xs: 'column', md: 'row' }}
                    sx={{ alignItems: { md: 'center' }, justifyContent: { md: 'space-between' } }}
                >
                    <Typography variant="h5" sx={{ typography: { xs: 'h5', sm: 'h4' } }}>
                        Ready to find the one?
                    </Typography>
                    <Button size="large" variant="contained" sx={{ width: { sm: '240px' } }} href="/cars">
                        Start a search
                    </Button>
                </Stack>
            </Paper>
        </KmxContainer>
    );
};

export default ReadyToFind;
